var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('DemoHeader'),_c('DemoContent'),_c('DemoCards'),_c('DemoGridBullet'),_c('DemoDropdown'),_c('DemoContentSteps'),_c('DemoGridArticles'),_c('DemoArticle'),_c('DemoTag'),_c('DemoCta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }